/**
 * src/lib/analytics/gtag.ts
 *
 * Google Analytics 4 (gtag) yardımcıları — Measurement ID env'den okunur
 * (`NEXT_PUBLIC_GA_ID`). ID boşsa GA tamamen devre dışı (site sağlam çalışır).
 *
 * Olay takibi consent-aware: gtag yalnızca analytics onayı verilince yüklenir
 * (GoogleAnalytics component). trackEvent gtag yoksa sessizce no-op — bu yüzden
 * onay yoksa hiçbir olay/çerez gitmez (kvkk-compliance.md).
 */

/** GA4 Measurement ID — 'G-XXXXXXXXXX'. Boşsa GA kapalı. */
export const GA_ID = process.env.NEXT_PUBLIC_GA_ID ?? ''

/** GA etkin mi (geçerli bir ID girilmiş mi). */
export const GA_ENABLED = /^G-[A-Z0-9]+$/i.test(GA_ID)

/** Olay parametreleri — GA4 custom event params. */
export type GtagParams = Record<string, string | number | boolean | undefined>

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

/**
 * trackEvent — GA4'e custom event gönderir. gtag yüklü değilse (onay yok / GA
 * kapalı) sessizce no-op.
 *
 * @param name Olay adı (snake_case — örn. 'whatsapp_click')
 * @param params Opsiyonel olay parametreleri
 */
export function trackEvent(name: string, params?: GtagParams): void {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('event', name, params ?? {})
}

/**
 * pageview — SPA route değişiminde manuel sayfa görüntüleme olayı.
 * @param path Görüntülenen yol (pathname)
 */
export function pageview(path: string): void {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  })
}
